import { AppBar, Box, IconButton, Stack, Toolbar } from '@mui/material';
// material
import { alpha, styled } from '@mui/material/styles';
// components
import Iconify from '../Iconify';
import AccountPopover from './AccountPopover';
import NotificationsPopover from './NotificationsPopover';
import { useParams } from 'react-router-dom';
import React from 'react';

// ----------------------------------------------------------------------

const DRAWER_WIDTHOpen = 20;
const DRAWER_WIDTHClose = 8;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardNavbar({ onOpenSidebar , isOpenSidebarDesktop }) {
 const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  top: '30px', // Position below sticky header ad
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${ isOpenSidebarDesktop ? DRAWER_WIDTHClose : DRAWER_WIDTHOpen}%)`,
  },
}));

  return (
     <RootStyle>
      <ToolbarStyle>
        <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary', display: { lg: 'none' } }}>
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>
       
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          <NotificationsPopover />
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle> 
  );
}
